import * as style from "@COMPONENTS/style/detailpackage/itinerarychorusM";

/** component */
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {TSchedule} from "@COMPONENTS/product/types";
import useAgencyInfo from "@QUERIES/essential/agency/useAgencyInfo";

const ScheduleManagerComponent = ({query, eventDetail}: TSchedule) => {
	const {agentCd = ""} = query;
	const {mgmDeptNm, mgmUserTelNo, mgmUserInfo = "N", phoneDirect, mgmUserEmail, mgmUserNm} = eventDetail;
	const agency = useAgencyInfo(agentCd, {enabled: !!agentCd});
	const {agenAddr, agenFax, agenNm, agenTel} = agency.data.body;
	return (
		<style.InfoList>
			{!agentCd && mgmUserInfo === "Y" && (
				<>
					<li>
						<span>부서</span>
						<span>{mgmDeptNm}</span>
					</li>
					<li>
						<span>대표번호</span>
						<span>{phoneDirect}</span>
					</li>
				</>
			)}
			{!agentCd && mgmUserInfo === "N" && (
				<>
					<li>
						<span>담당자</span>
						<span>{mgmUserNm}</span>
					</li>
					<li>
						<span>대표번호</span>
						<span>{mgmUserTelNo ?? phoneDirect}</span>
					</li>
					<li>
						<span>이메일</span>
						<span>{mgmUserEmail}</span>
					</li>
				</>
			)}
			{agentCd && !agency.isFetching && (
				<>
					{agenNm && (
						<li>
							<span>문의</span>
							<span>{agenNm}</span>
						</li>
					)}
					{agenTel && (
						<li>
							<span>전화번호</span>
							<span>{agenTel}</span>
						</li>
					)}
					{agenFax && (
						<li>
							<span>FAX</span>
							<span>{agenFax}</span>
						</li>
					)}
					{agenAddr && (
						<li>
							<span>주소</span>
							<span>{agenAddr}</span>
						</li>
					)}
				</>
			)}
		</style.InfoList>
	);
};

const ScheduleManager = (props: TSchedule) => (
	<ErrorBoundary logMsg="ScheduleManager Error">
		<ScheduleManagerComponent {...props} />
	</ErrorBoundary>
);

export default ScheduleManager;
